import { Exception } from '@nemuru-eng/js-api-client';
import React, { ReactNode } from 'react';

import { ErrorMessage } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/ErrorMessage';
import { ErrorInDialog } from '@/components/shared/components/ErrorBoundary/types/ErrorInDialog';

// https://reactjs.org/docs/error-boundaries.html

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    if (!this.state.error) {
      this.setState((s) => ({ ...s, hasError: true, error }));
    }
  }

  render() {
    if (this.state.hasError && this.state.error instanceof ErrorInDialog) {
      console.error(this.state.error);

      // show as a closable dialog, keep page in background
      return (
        <>
          <ErrorMessage
            error={this.state.error.errorInstance}
            isAsync
            retryFn={this.state.error.retryFn}
            clearErrorBoundary={() => {
              this.setState((s) => ({ ...s, hasError: false, error: undefined }));
            }}
          />
          {this.props.children}
        </>
      );
    }
    if (this.state.hasError) {
      console.error(this.state.error);

      // break page, show without any other content
      return <ErrorMessage error={this.state.error} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error | Exception;
}
